import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaWindowClose } from 'react-icons/fa';
import CommonModal from './CommonModal';
import { catchError, commonModalSetting, enterFn, outClick, maskingInfo } from 'JS/common';
import { extendSubscription } from 'JS/API';

const SubscriptionExtendModal = ({ setModal, item, setAlertBox, setAlert }) => {
  const [days, setDays] = useState('30');
  const [loading, setLoading] = useState(false);
  const [innerAlertBox, setInnerAlertBox] = useState({
    mode: '',
    context: '',
    bool: false,
  });
  const [innerAlert, setInnerAlert] = useState('');
  const navigate = useNavigate();

  const { user_pk, user_name, user_email, merchant_name, end_at } = item;

  const handleExtend = async () => {
    const daysNum = parseInt(days, 10);
    if (!daysNum || daysNum < 1 || daysNum > 366) {
      return commonModalSetting(
        setInnerAlertBox,
        true,
        'alert',
        '연장 일수는 1일에서 366일 사이로<br/>입력해 주세요.'
      );
    }

    setLoading(true);
    const result = await extendSubscription(user_pk, daysNum);
    setLoading(false);

    if (typeof result === 'object') {
      setInnerAlert('success');
      commonModalSetting(
        setInnerAlertBox,
        true,
        'alert',
        `이용권이 ${daysNum}일 연장되었습니다.`
      );
    } else {
      catchError(result, navigate, setInnerAlertBox, setInnerAlert);
    }
  };

  const formatDate = dateStr => {
    if (!dateStr) return '-';
    return dateStr.replace('T', ' ').substring(0, 10);
  };

  const calculateNewEndDate = () => {
    if (!end_at || !days) return '-';
    const endDate = new Date(end_at);
    const daysNum = parseInt(days, 10) || 0;
    endDate.setDate(endDate.getDate() + daysNum);
    return endDate.toISOString().substring(0, 10);
  };

  useEffect(() => {
    window.addEventListener('click', e => outClick(e, setModal));
    return () => window.removeEventListener('click', e => outClick(e, setModal));
  }, []);

  return (
    <>
      <div className='modal-background'>
        <div className='modal subscription-extend'>
          <div className='topBar'>
            <h2>이용권 연장</h2>
            <div onClick={() => setModal(false)}>
              <FaWindowClose />
            </div>
          </div>
          <hr />
          <div className='wrap'>
            <div className='info-section'>
              <div className='info-row'>
                <span className='label'>회원명</span>
                <span className='value'>
                  {user_name ? maskingInfo('name', user_name) : '-'}
                </span>
              </div>
              <div className='info-row'>
                <span className='label'>이메일</span>
                <span className='value'>
                  {user_email ? maskingInfo('email', user_email) : '-'}
                </span>
              </div>
              <div className='info-row'>
                <span className='label'>이용권</span>
                <span className='value'>{merchant_name || '-'}</span>
              </div>
              <div className='info-row'>
                <span className='label'>현재 만료일</span>
                <span className='value'>{formatDate(end_at)}</span>
              </div>
            </div>

            <div className='input-section'>
              <label>연장 일수</label>
              <div className='input-row'>
                <input
                  type='number'
                  min='1'
                  max='366'
                  value={days}
                  onChange={e => setDays(e.target.value)}
                  onKeyDown={e => enterFn(e, handleExtend)}
                  placeholder='연장할 일수 입력'
                />
                <span className='suffix'>일</span>
              </div>
              <p className='hint'>1일 ~ 366일까지 입력 가능합니다.</p>
            </div>

            <div className='preview-section'>
              <div className='preview-row'>
                <span className='label'>연장 후 만료일</span>
                <span className='value highlight'>{calculateNewEndDate()}</span>
              </div>
            </div>

            <div className='footer'>
              <div className='btn-group'>
                <button
                  className='confirm-btn'
                  onClick={handleExtend}
                  disabled={loading}>
                  {loading ? '처리 중...' : '연장하기'}
                </button>
                <button className='cancel-btn' onClick={() => setModal(false)}>
                  취소
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {innerAlertBox.bool && (
        <CommonModal
          setModal={setInnerAlertBox}
          modal={innerAlertBox}
          okFn={() => {
            if (innerAlert === 'success') {
              setModal(false);
            } else if (innerAlert === 'logout') {
              navigate('/');
            }
          }}
        />
      )}
    </>
  );
};

export default SubscriptionExtendModal;